var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardCollapse',{attrs:{"title":_vm.$t('global.advanced-auto-scaling-usage-details')}},[_c('CardTabledList',{attrs:{"items":_vm.getItems()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }